import { useFeatureFlag } from '@/store/slices/api/featureFlagsApiSlice';

export const useDeviceAndLeadsRecallFeatureFlag = () => {
  const isRecallListPageEnabled = useFeatureFlag('device_and_leads_recall');

  return { isRecallListPageEnabled };
};
